import makeRequest from 'api/makeRequest';
import { handleError } from 'services/ErrorService/ErrorService';
import { CLEAR_CUSTOMER_SEARCH, SET_CUSTOMERS, SET_SELECTED_CUSTOMER } from 'constants/customerSearch';
import environment from '../../environment';
import { getSelectedCustomer } from 'selectors/tools';
import { extractNonHistoricalTicketIdFromState, getSimplrAccountIdOfSelectedTicket } from 'extractFromState';
import { lookupAndSetAccounts } from './DecisionTree/accountSearchActions';
const { ACCOUNT_BASE_URL } = environment.accountData;
const { CUSTOMER_BASE_URL } = environment.customerData;

export const reinstateAccount = () => async (dispatch, getState) => {
  const state = getState();

  const selectedCustomer = getSelectedCustomer(state);
  const accountId = selectedCustomer.customerId;
  const simplrAccountId = getSimplrAccountIdOfSelectedTicket(state);
  const conversationId = extractNonHistoricalTicketIdFromState(state);

  if (!accountId || !simplrAccountId) {
    throw new Error('Looks like there is no selected customer');
  }

  const payload = {
    simplrAccountId,
    conversationId,
  };

  const { success, errors } = await makeRequest(`${ACCOUNT_BASE_URL}/${accountId}/reinstateAccount`, {
    method: 'post',
    data: payload,
  });

  if (!success) {
    throw new Error(errors);
  }

  // update selected account in case it needs to be shown in custom widget
  await dispatch(lookupAndSetAccounts(accountId, simplrAccountId));
};

export const clearCustomerSearch = () => ({
  type: CLEAR_CUSTOMER_SEARCH,
});
const setCustomers = (customers) => ({
  type: SET_CUSTOMERS,
  customers,
});
export const setSelectedCustomer = (customer) => ({
  type: SET_SELECTED_CUSTOMER,
  customer,
});

export const lookupAndSetCustomers = (email, simplrAccountId) => {
  return async (dispatch) => {
    dispatch(clearCustomerSearch());
    const params = { email, simplrAccountId };
    try {
      const { customers } = await makeRequest(CUSTOMER_BASE_URL, { params });
      if (!Array.isArray(customers)) {
        throw new Error(`Expected an array for customers, received ${customers}`);
      }
      dispatch(setCustomers(customers));
    } catch (error) {
      handleError({
        error,
        customMessage: 'Something went wrong when searching for customers.',
        customFields: { ...params },
        showPopup: true,
      });
    }
  };
};
